// ExcludedUpcs.js
// Array of UPCs to exclude from product listings
//
// Usage:
//   Add UPCs (as strings) to this array to filter them out from product results

const excludedUpcs = [
  // Add UPCs to exclude here, e.g.:
  // "0000000001234",
  // "0000000005678"
];

export default excludedUpcs;

